/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { RHFTextField, FormProvider } from '../../components/hook-form';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CircularProgress,
  Stack,
  Typography,
  Autocomplete,
} from '@mui/material';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import axiosInstance from 'utils/axios';
import axios from 'axios';
import usePortalId from 'hooks/portal/usePortalId';
import { ROOT_NAVIGATION } from '../../../src/routes/paths';
import TextField from '@mui/material/TextField';
import _ from 'lodash';
import { HOST_API } from 'config';
import { useLocation, useNavigate } from 'react-router-dom';
import { Info } from '@mui/icons-material';
import PartialPageSpinner from 'components/PartialPageSpinner';

type FormValuesProps = {
  price: string;
  name: string;
  description: string;
  product_image: string;
  hs_product_id: string;
  portal_id: number;
};
type ArrayOfObj = { label: string; value: string };
export function EditProduct() {
  const interval: { current: any } = useRef(51);
  const defaultImagePath =
    'https://media.istockphoto.com/id/1159947597/vector/add-photos-concept-line-icon-simple-element-illustration.jpg?s=612x612&w=0&k=20&c=eU2aJxlWFKDle1-NS8KBOzRYrEgSSJ4QVKorAmp467M=';
  const portalId = usePortalId();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const location = useLocation();
  const [options, setOptions] = useState<ArrayOfObj[]>([]);
  const [optionSearchValue, setOptionSearchValue] = useState<string>('');
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [disableAutocomplete, setDisableAutocomplete] =
    useState<boolean>(false);
  const [autocompleteLoading, setAutocompleteLoading] =
    useState<boolean>(false);
  const [selectedvalue, setSelectedValue] = useState<ArrayOfObj | null>(null);
  const [fetchingHubspotId, setFetchingHubspotId] = useState<boolean>(true);

  const links = React.useMemo(
    () => [
      {
        name: t('dashboard'),
        href: ROOT_NAVIGATION.general.home(portalId),
      },
      {
        name: t('products'),
        href: ROOT_NAVIGATION.general.products(portalId),
      },
      {
        name: t('edit'),
      },
    ],
    [portalId, t]
  );

  const onSubmit = async (data: FormValuesProps) => {
    try {
      const respo = await axiosInstance.post(
        `${HOST_API}/formpayhome/product/updateFpProduct/${location.state?.pro_id}`,
        {
          ...data,
        }
      );
      if (respo.data.success) {
        enqueueSnackbar(respo.data.message, { variant: 'success' });
        setTimeout(() => {
          navigate(ROOT_NAVIGATION.general.products(portalId));
        }, 1000);
      }
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  const productSchema = () => {
    if (disableAutocomplete) {
      return Yup.object().shape({
        price: Yup.number()
          .nullable(true)
          .typeError(t('product_price_required'))
          .required(t('product_price_required'))
          .min(1, t('min_product_price'))
          .max(999999, t('max_product_price')),
        name: Yup.string()
          .required(t('product_name_required'))
          .min(3, t('product_name_at_least_have'))
          .max(30, t('product_name_at_most_have')),
        product_image: Yup.string().url(),
        description: Yup.string()
          .required(t('product_description_required'))
          .min(6, t('product_description_at_least_have'))
          .max(100, t('product_description_at_most_have')),
        hs_product_id: Yup.string(),
      });
    } else {
      return Yup.object().shape({
        price: Yup.number()
          .nullable(true)
          .typeError(t('product_price_required'))
          .required(t('product_price_required'))
          .min(1, t('min_product_price'))
          .max(999999, t('max_product_price')),
        name: Yup.string()
          .required(t('product_name_required'))
          .min(3, t('product_name_at_least_have'))
          .max(30, t('product_name_at_most_have')),
        product_image: Yup.string().url(),
        description: Yup.string()
          .required(t('product_description_required'))
          .min(6, t('product_description_at_least_have'))
          .max(100, t('product_description_at_most_have')),
        hs_product_id: Yup.string().required(t('hs_product_id_required')),
      });
    }
  };

  function getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const handleDrop = async (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    name: string
  ) => {
    setButtonLoading(true);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    if (e.target.files) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      const base64Data = await getBase64(e.target.files[0]);
      try {
        const res = await axiosInstance.post(
          '/formpayhome/portal/getUploadedImageUrl',
          {
            imageType: name,
            base64_imageString: base64Data,
          }
        );

        if (res.data.success) {
          setValue('product_image', res.data.image_url);
        }
      } catch (err) {
        if (axios.isAxiosError(err)) {
          enqueueSnackbar(err.message, { variant: 'error' });
        }
      } finally {
        setButtonLoading(false);
      }
    }
  };

  const defaultValues = {
    price: location.state?.price,
    name: location.state?.name,
    description: location.state?.description,
    product_image: location.state?.image,
    hs_product_id: location.state?.id,
    portal_id: Number(portalId),
  };

  const methods = useForm<FormValuesProps>({
    mode: 'all',
    resolver: yupResolver(productSchema()),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting, errors },
    watch,
    setError,
    setValue,
  } = methods;

  const selectError =
    errors.hs_product_id && errors.hs_product_id.message !== undefined
      ? true
      : false;

  useEffect(() => {
    const fetchProducts = async () => {
      setAutocompleteLoading(true);
      try {
        const result = await axiosInstance.post(
          `${HOST_API}/formpayhome/product/searchHubProduct?product_name=${optionSearchValue}&portal_id=${portalId}`
        );
        if (result.data.data.data.length > 0) {
          const temp: ArrayOfObj[] = [];
          // eslint-disable-next-line array-callback-return
          result.data.data.data.map((item: any) => {
            temp.push({
              label: item.properties.name + ' - ' + item.id,
              value: item.id,
            });
          });
          setOptions(temp);
          setDisableAutocomplete(false);
        }
      } catch (error: any) {
        if (optionSearchValue.length === 0) {
          setDisableAutocomplete(true);
        }
      }
      setAutocompleteLoading(false);
    };
    interval.current = setTimeout(() => {
      fetchProducts();
    }, 500);

    return () => clearTimeout(interval.current);
  }, [optionSearchValue]);

  useEffect(() => {
    const fetchAllOptionOnce = async () => {
      try {
        const result = await axiosInstance.post(
          `${HOST_API}/formpayhome/product/searchHubProduct?product_name=${optionSearchValue}&portal_id=${portalId}`
        );

        if (result.data.success) {
          setFetchingHubspotId(false);
        }
        if (result.data.data.data.length > 0) {
          // eslint-disable-next-line array-callback-return
          result.data.data.data.map((item: any) => {
            if (item.id === location.state.id) {
              setValue('hs_product_id', item.id);
              setSelectedValue({
                label: item.properties.name + ' - ' + item.id,
                value: item.id,
              });
            }
          });
        }
      } catch (error: any) {
        if (optionSearchValue.length === 0) {
          setDisableAutocomplete(true);
        }
      }
    };
    fetchAllOptionOnce();
  }, []);
  if (fetchingHubspotId) {
    return <PartialPageSpinner />;
  }

  return (
    <div className='d-flex mx-auto w-[85%] items-center justify-center'>
      <HeaderBreadcrumbs heading={t('products')} links={links} />
      <Typography sx={{ marginBottom: '25px' }}>{t('edit_product')}</Typography>
      <Card className='border border-gray-500 px-10 py-10'>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <div style={{ width: '60%' }}>
              <Stack spacing={3} sx={{ width: '100%' }}>
                <RHFTextField
                  id='name'
                  name='name'
                  label={t('product_name')}
                  sx={{ width: 'auto' }}
                />
                <RHFTextField
                  type='number'
                  id='price'
                  name='price'
                  label={t('product_price')}
                  sx={{ width: 'auto' }}
                />
                <Autocomplete
                  id='combo-box'
                  options={options}
                  loading={autocompleteLoading}
                  value={selectedvalue}
                  onChange={(e: any, newValue: any | null) => {
                    if (newValue === null) {
                      setValue('hs_product_id', '');
                      setSelectedValue(null);
                    } else {
                      setSelectedValue(newValue);
                      setValue('hs_product_id', newValue.value);
                    }
                    setError(
                      'hs_product_id',
                      { type: 'focus' },
                      { shouldFocus: false }
                    );
                  }}
                  inputValue={optionSearchValue}
                  onInputChange={(event, newInputValue) => {
                    setOptionSearchValue(newInputValue);
                  }}
                  renderInput={params => {
                    return (
                      <TextField
                        {...params}
                        disabled={disableAutocomplete}
                        label={t('hubspot_product_id')}
                        error={selectError}
                        helperText={
                          errors.hs_product_id &&
                          errors.hs_product_id.message !== undefined
                            ? t(errors.hs_product_id.message)
                            : ''
                        }
                      />
                    );
                  }}
                />
                {disableAutocomplete ? (
                  <div className='mt-2 flex items-center text-[14px] text-gray-600'>
                    <Info sx={{ width: '15px', height: '15px' }} />{' '}
                    <span className='ml-1'>
                      {t('no_hubspot_products_in_your_portal')}
                    </span>
                  </div>
                ) : (
                  ''
                )}
                <RHFTextField
                  id='portal_id'
                  name='portal_id'
                  label={t('portal_id')}
                  sx={{ width: 'auto' }}
                  value={portalId}
                  disabled
                />

                <RHFTextField
                  id='description'
                  name='description'
                  label={t('product_description')}
                  sx={{ width: 'auto' }}
                />
              </Stack>
            </div>
            <div style={{ width: '40%', marginTop: '10px' }}>
              {watch('product_image').length === 0 ? (
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                  }}
                >
                  {buttonLoading ? (
                    <div
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                        border: '2px solid lightgray',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CircularProgress style={{ color: 'lightgray' }} />
                    </div>
                  ) : (
                    <img
                      src={location.state?.image || defaultImagePath}
                      alt='title'
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                        border: '2px solid lightgray',
                      }}
                    />
                  )}
                </Stack>
              ) : (
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                  }}
                >
                  {buttonLoading ? (
                    <div
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                        border: '2px solid lightgray',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CircularProgress style={{ color: 'lightgray' }} />
                    </div>
                  ) : (
                    <img
                      src={watch('product_image')}
                      alt='title'
                      style={{
                        width: '180px',
                        height: '180px',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                </Stack>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <input
                  accept='image/*'
                  style={{ display: 'none' }}
                  id='product_image'
                  name='product_image'
                  onChange={e => handleDrop(e, 'product_image')}
                  type='file'
                />
                <label htmlFor='product_image'>
                  <LoadingButton
                    variant='outlined'
                    component='span'
                    sx={{ mt: '10px' }}
                    loading={buttonLoading}
                  >
                    {t('upload_image')}
                  </LoadingButton>
                </label>
              </div>
            </div>
          </div>
          <LoadingButton
            sx={{ width: '60%', marginTop: '10px' }}
            size='large'
            type='submit'
            variant='contained'
            loading={isSubmitting}
          >
            {t('update')}
          </LoadingButton>
        </FormProvider>
      </Card>
    </div>
  );
}

export default EditProduct;
